var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.625C5.47918 2.625 2.625 5.47918 2.625 9C2.625 12.5208 5.47918 15.375 9 15.375C12.5208 15.375 15.375 12.5208 15.375 9C15.375 5.47918 12.5208 2.625 9 2.625ZM1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9Z",
    fill: "#9C9DA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28985 6.38938C8.72158 6.35054 8.18118 6.61892 7.99164 7.00033C7.85338 7.27853 7.51578 7.39198 7.23758 7.25373C6.95938 7.11547 6.84593 6.77787 6.98418 6.49967C7.43596 5.59059 8.49536 5.20746 9.36655 5.267C9.81819 5.29786 10.2849 5.44843 10.6485 5.76708C11.0254 6.09742 11.25 6.57373 11.25 7.15599C11.25 8.02668 10.6613 8.54213 10.2745 8.88079C10.2544 8.89842 10.2348 8.91558 10.2158 8.93228C9.77742 9.31899 9.5625 9.54887 9.5625 9.9375C9.5625 10.2482 9.31066 10.5 9 10.5C8.68934 10.5 8.4375 10.2482 8.4375 9.9375C8.4375 9.00011 9.04611 8.46367 9.45178 8.10611C9.45846 8.10022 9.46509 8.09438 9.47166 8.08858C9.93286 7.68178 10.125 7.48458 10.125 7.15599C10.125 6.88375 10.0298 6.72075 9.90699 6.61312C9.77084 6.49378 9.55794 6.4077 9.28985 6.38938Z",
    fill: "#9C9DA9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12C8.25 11.5858 8.58579 11.25 9 11.25C9.41421 11.25 9.75 11.5858 9.75 12C9.75 12.4142 9.41421 12.75 9 12.75C8.58579 12.75 8.25 12.4142 8.25 12Z",
    fill: "#9C9DA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2b3ef3135aa7e2ad2a740315fa6d99d3.svg";
export { ForwardRef as ReactComponent };